<template>
  <div>
    <flat-pickr
        v-model="dummy_value"
        :config="flatpickr_config"
        class="form-control rounded-none"
        placeholder="Set dates"
        name="date">
    </flat-pickr>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';

export default {
  name: "DateRangePicker",
  components: {
    flatPickr
  },
  props: {
    enabled_default: {
      type: Boolean,
      default: true,
    },
    earliest_date: {
      type: String,
      default: ""
    },
    latest_date: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      dummy_value: "",
      from_date: new Date(),
      to_date: new Date(),
      livewire: {},
      flatpickr_config: {
        mode: "range",
        minDate: this.earliest_date,
        maxDate: this.latest_date,
        onClose: this.close,
      }
    }
  },
  mounted() {
    this.livewire = Livewire;
  },
  methods: {
    close(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
        let startDate = selectedDates[0];
        let endDate = selectedDates[1];
        this.from_date = startDate;
        this.to_date = endDate;
        this.livewire.emit('setDates', [this.from_date, this.to_date]);
      }
    }
  }
}
</script>

<style scoped>

</style>
